export const DEFERRED_REMOVAL_TIMEOUT_MS = 2000;

export const computeBagDiff = (current, next, oldQuantity, newQuantity) => {
  const previousQuantity = oldQuantity ?? 0;
  const currentQuantity = newQuantity ?? 0;

  const currentIds = new Set(current.map(item => item.id));
  const nextIds = new Set(next.map(item => item.id));
  const nextById = new Map(next.map(item => [item.id, item]));

  const removed = current.filter(({ id }) => !nextIds.has(id));
  const addedItems = next.filter(({ id }) => !currentIds.has(id));

  const hasRemovedItems = removed.length > 0;
  const hasAddedItems = addedItems.length > 0;
  const sameQuantity = currentQuantity === previousQuantity;
  const quantityChanged = currentQuantity !== previousQuantity;
  const sameItemCount = current.length === next.length;
  const noItemIdentityChanges = !hasRemovedItems && !hasAddedItems;

  const hasSubscriptionAdded = addedItems.some(
    ({ itemType }) => itemType === "Subscription"
  );

  const itemsWereAdded =
    currentQuantity > previousQuantity || hasSubscriptionAdded;

  const itemsWereSwapped =
    hasRemovedItems && hasAddedItems && sameQuantity && sameItemCount;

  const itemSizeChanged =
    noItemIdentityChanges &&
    current.length > 0 &&
    sameItemCount &&
    current.some(item => {
      const nextItem = nextById.get(item.id);

      return (
        nextItem &&
        (item.variantId !== nextItem.variantId || item.size !== nextItem.size)
      );
    });

  return {
    removed,
    addedItems,
    itemsWereAdded,
    itemsWereSwapped,
    quantityChanged: noItemIdentityChanges && quantityChanged,
    itemSizeChanged
  };
};

export const determineCartAction = (
  itemsWereSwapped,
  quantityChanged,
  newQuantity,
  oldQuantity,
  itemsWereAdded,
  itemSizeChanged
) => {
  if (itemsWereSwapped) {
    return "size_change";
  }
  if (quantityChanged) {
    return (newQuantity || 0) > (oldQuantity || 0)
      ? "quantity_increase"
      : "quantity_decrease";
  }
  if (itemsWereAdded) {
    return "item_added";
  }
  if (itemSizeChanged) {
    return "size_change";
  }
  return "item_removed";
};
